import React, { useEffect, useState } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { useParams, Link } from "react-router-dom";
import Slider from "react-slick";

const API = "https://labwayscientific.com/backend/wp-json/wc/v3";
const CK = "ck_e1c36267e6a5e3cb0198558262bf2096181b4a0b";
const CS = "cs_fc900ba31d63fade2cfba415abe8a599366c20b0";

function ProductDetail() {

  const { id } = useParams();

  const [product, setProduct] = useState(null);
  const [related, setRelated] = useState([]);

  const [activeImage, setActiveImage] = useState("");
  const [zoom, setZoom] = useState(false);

  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });

  // 🔥 Fetch product
  useEffect(() => {
    fetch(`${API}/products/${id}?consumer_key=${CK}&consumer_secret=${CS}`)
      .then(res => res.json())
      .then(data => {
        setProduct(data);
        setActiveImage(data.images?.[0]?.src);
      });
  }, [id]);

  // 🔥 Fetch related
  useEffect(() => {
    if (!product) return;

    const catId = product.categories[0]?.id;
    if (!catId) return;

    fetch(`${API}/products?category=${catId}&per_page=10&exclude=${product.id}&consumer_key=${CK}&consumer_secret=${CS}`)
      .then(res => res.json())
      .then(data => setRelated(data));

  }, [product]);

  if (!product) return <p>Loading...</p>;

  const sliderSettings = {
    dots: false,
    infinite: related.length > 4,
    speed: 500,
    slidesToShow: 4,
    arrows: true,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } }
    ]
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await fetch(
      "https://labwayscientific.com/backend/wp-json/custom/v1/enquiry",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          product: product.name
        })
      }
    );

    const data = await res.json();

    if (data.status === "success") {
      alert("Enquiry sent!");
      setShowForm(false);
      setFormData({ name: "", email: "", phone: "", message: "" });
    } else {
      alert("Error sending enquiry");
    }
  };

  return (
    <div>

      <Header />

      <div className='container main-contant'>
        <div className='inner-page-container'>

          {/* Breadcrumb */}
          <div className='breadcrumb-wrapper' style={{ marginBottom: "15px" }}>
            <Link to="/">Home</Link> / 
            <Link to="/shop"> Shop</Link> / 
            <span> {product.name}</span>
          </div>

          <div className='product-info-main'>

            {/* 🔥 IMAGE SECTION */}
            <div className='product-media' style={{ flex: 1 }}>

              <img
                src={activeImage}
                alt={product.name}
                style={{
                  width: "100%",
                  height: "400px",
                  objectFit: "cover",
                  cursor: "zoom-in"
                }}
                onClick={() => setZoom(true)}
              />

              {/* Thumbnails */}
              <div className='product-gallery-thumb-wrapper' style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                {product.images.map((img, index) => (
                  <img
                    key={index}
                    src={img.src}
                    onClick={() => setActiveImage(img.src)}
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "cover",
                      cursor: "pointer",
                      border: activeImage === img.src
                        ? "2px solid #f39c12"
                        : "1px solid #ddd"
                    }}
                  />
                ))}
              </div>

            </div>

            {/* 🔥 DETAILS */}
            <div className='product-details' style={{ flex: 1 }}>
              <h1 className='product-title'>{product.name}</h1>

              <p className='product-sku'>{product.sku}</p>

              <div dangerouslySetInnerHTML={{ __html: product.description }} />

              <button
                className="btn btn-primary enquiry-btn"
                onClick={() => setShowForm(true)}
              >
                Enquiry Now
              </button>
            </div>

          </div>

          {/* 🔥 RELATED */}
          {related.length > 0 && (
            <div className='related-product-wrapper' style={{ marginTop: "60px" }}>

              <div style={{ marginBottom: "20px" }} className="sec-title"><h2>You may also like</h2><div class="separator"></div></div>

              <Slider {...sliderSettings}>
                {related.map((item) => (
                   <div key={item.id} style={slideItem}>
                                  <div style={cardStyle}>
                                    <Link
                                      to={`/product/${item.id}`}
                                      style={{ textDecoration: "none", color: "#000" }}
                                    >
                                      <div style={imageWrap}>
                                        <img
                                          src={item.images?.[0]?.src || "/no-image.png"}
                                          alt={item.name}
                                          style={imageStyle}
                                        />
                                      </div>
                  
                                      <h4 style={titleStyle}>{item.name}</h4>
                                    </Link>
                                  </div>
                                </div>
                ))}
              </Slider>
            </div>
          )}

        </div>
      </div>

      {/* 🔥 ZOOM POPUP */}
      {zoom && (
        <div style={zoomOverlay} onClick={() => setZoom(false)}>
          <img src={activeImage} style={zoomImage} />
        </div>
      )}

      {/* 🔥 ENQUIRY POPUP */}
      {showForm && (
        <div style={overlay}>
          <div style={popup}>
            <h3>Enquiry Form</h3>

            <form onSubmit={handleSubmit}>
              <input name="name" placeholder="Name" onChange={handleChange} required />
              <input name="email" placeholder="Email" onChange={handleChange} required />
              <input name="phone" placeholder="Phone" onChange={handleChange} required />
              <textarea name="message" placeholder="Message" onChange={handleChange} />

              <button type="submit">Submit</button>
              <button type="button" onClick={() => setShowForm(false)}>Close</button>
            </form>
          </div>
        </div>
      )}

      <Footer />

    </div>
  );
}

export default ProductDetail;



// 🎨 STYLES

// const cardStyle = {
//   border: "1px solid #eee",
//   padding: "10px",
//   textAlign: "center"
// };

const zoomOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.8)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999
};

const zoomImage = {
  maxWidth: "90%",
  maxHeight: "90%"
};

const overlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};

const popup = {
  background: "#fff",
  padding: "20px",
  width: "350px"
};



const cardStyle = {
  border: "1px solid #ddd",
  padding: "10px",
  background: "#fff",
  textAlign: "center",
  minHeight: "240px",
  margin: "0 10px",
};

const imageWrap = {
  height: "150px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const imageStyle = {
  maxWidth: "100%",
  maxHeight: "100%",
  objectFit: "contain",
};

const titleStyle = {
  fontSize: "13px",
  marginTop: "10px",
  minHeight: "40px",
};

const arrowButtonBase = {
  position: "absolute",
  top: "40%",
  zIndex: 2,
  border: "none",
  background: "#97043a",
  color: "#fff",
  width: "34px",
  height: "34px",
  borderRadius: "50%",
  lineHeight: "34px",
  textAlign: "center",
};

const arrowLeft = {
  ...arrowButtonBase,
  left: "0",
};

const arrowRight = {
  ...arrowButtonBase,
  right: "0",
};

const sliderWrap = {
  padding: "10px 40px",
};

const slideItem = {
  padding: "10px 0",
};
